import { get, post, put, patch } from "../../../services/api/Config"

export function SearchBoards({ params = {}, lang }) {
  return get({ url: `/v1/admin/board-of-directors`, params, lang })
}
export function GetBoardsById({ id, lang }) {
  return get({ url: `/v1/admin/board-of-directors/${id}`, lang })
}
export function CreateBoards({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/board-of-directors`, params, data, lang })
}
export function UpdateBoards({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/board-of-directors/${id}`, params, data, lang })
}
export function PatchBoards({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/board-of-directors/${id}`, params, data, lang })
}
export function DeleteBoards({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/board-of-directors/mutiDelete`, params, data, lang })
}
